<template>
  <div v-if="loading" class="d-flex align-center justify-center fill-height">
    <Loader label="Создание нового GSA" />
  </div>
  <GsaCreator v-else @created="create_gsa" />
</template>

<script>
import GsaCreator from '../components/GsaCreator.vue'
import Loader from '../components/ui/Loader.vue'

export default {
  data: () => ({
    loading: false
  }),
  methods:{
    async create_gsa(item){
      this.loading = true
      try {
        let newGsa = await this.$store.dispatch('create_gsa', item)
        
        this.$router.replace(`/gsa/${newGsa.id}`)
      } catch (e) {
        console.log(e)
      }

      this.loading = false
    }
  },
  components:{
    GsaCreator,
    Loader
  }
}
</script>